export default {
  gradioStream: '/tpilot/log/stream ',
  useStreamCache: '/aisee/tpilot/use_stream_cache',
};
